<widget-skeleton *ngIf="isLoading && !hasData" [type]="type" [isFullscreenView]="isFullscreenView"></widget-skeleton>

<div *ngIf="hasData === false && isLoadingSuccess" class="no-data">
    <widget-no-data></widget-no-data>
</div>

<div *ngIf="isLoadingError" class="error">
    <widget-error [title]="title" class="center"></widget-error>
</div>
